var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.457 0l-1.414 1.415 4.761 4.76H0v2h17.804l-4.761 4.761 1.414 1.414 5.761-5.761 1.414-1.414-1.414-1.414z","fillRule":"evenodd"}));
}

ArrowRight.defaultProps = {"width":"22","height":"15"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
